import { indonesianDayNames } from './constants'

// eslint-disable-next-line import/prefer-default-export
export const tableUsersWorkConfig = [
  {
    key: 'select',
    label: '',
    thStyle: {
      width: '40px',
      background: '#F4F4F4',
    },
    tdClass: 'text-medium',
  },
  {
    key: 'name',
    label: 'Nama',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      lineHeight: '2',
    },
    tdClass: 'text-medium',
  },
  ...indonesianDayNames.map((day, index) => ({
    key: `day_${index + 1}`,
    label: day.slice(0, 3),
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
    },
    tdClass: 'text-medium',
    class: 'p-1',
  })),
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      background: '#F4F4F4',
      paddingRight: '82px !important',
    },
    tdClass: 'text-medium',
    class: 'p-1 text-right pr-2',
  },
]
